// From https://product.hubteam.com/docs/crm-objects/primitives.html#fields-of-a-property-definition
export const FORMATTED = 'formatted';
export const UNFORMATTED = 'unformatted';
export const CURRENCY = 'currency';
export const DURATION = 'duration';
export const PERCENTAGE = 'percentage';